import { TWorkflowDefinition } from '@commenda/types';

export enum WorkflowVersionTargetOutcome {
  EDIT_IN_PLACE = 'EDIT_IN_PLACE',
  FORKED = 'FORKED',
  FAILED = 'FAILED',
}

export type TWorkflowVersionTarget =
  | {
      outcome:
        | WorkflowVersionTargetOutcome.EDIT_IN_PLACE
        | WorkflowVersionTargetOutcome.FORKED;
      targetWorkflowTemplateVersionId: string;
    }
  | { outcome: WorkflowVersionTargetOutcome.FAILED; error: string };

export type TForkBannerProps = {
  version: string;
  sourceVersionLabel: string | null;
  discardConfig?: {
    onDiscard: () => void;
    isDisabled: boolean;
  };
};

export type TBuilderConfirmation = {
  title: string;
  warnings: string[];
  confirmLabel: string;
  onConfirm: () => Promise<void>;
};

/** Handed over by the editor's chat-panel slot, so this module never imports the editor's context. */
/** Mirrors `TBuilderSelection` in the workflow-editor package; the two sides of this seam are declared
 *  by hand, as every contract in this estate is. */
export type TBuilderChatSelection = {
  id: string;
  stepType: string;
  name: string;
  otherSelectedCount: number;
};

/** Which document tab the author is on, supplied by the host that owns the tab strip. Absent means the
 *  host has no tabs, which is how the admin builder sends no context at all. */
export type TBuilderOpenTab = {
  openTab: string;
  openFormName?: string;
};

export type TBuilderCanvasBinding = {
  workflow: TWorkflowDefinition | null;
  applyRemoteWorkflow: (workflow: TWorkflowDefinition) => void;
  hasUnsavedChanges: () => boolean;
  markAsSaved: () => void;
  setIsReadOnly: (isReadOnly: boolean) => void;
  getSelection: () => TBuilderChatSelection | null;
};
